import {
  FC,
} from "react";

import st from "./OpenInput.module.scss";

interface Props {
  disabled: boolean,
  value: string,
  onChange: (value: string) => void,
}

export const OpenInput: FC<Props> = ({
  disabled,
  value,
  onChange,
}) => {
  return (
    <div className={st.wrapper}>
      <div className={st.input_block}>
        <input
          className={st.text_input}
          disabled={disabled}
          placeholder="Ваши мысли"
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
};
